import { Component, effect, EffectRef, ElementRef, inject, signal, Signal, untracked, ViewChild, WritableSignal } from '@angular/core';
import { ButtonComponent } from '@components/shared/button/button.component';
import { ButtonType } from '@models/enums/components/Button/ButtonType.enum';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';
import { DvmService } from '@services/dvm.service';
import anime from 'animejs';
import { version } from './../../../../../../package.json';

@Component({
  selector: 'app-legend',
  standalone: true,
  imports: [
    ButtonComponent
  ],
  templateUrl: './legend.component.html',
  styleUrl: './legend.component.css'
})
export class LegendComponent {

  @ViewChild('legendBtn', { read: ElementRef })
  private readonly legendBtn!: ElementRef<ButtonComponent>;

  @ViewChild('legendContent', { static: true, read: ElementRef})
  public legendContent!: ElementRef<HTMLDivElement>;

  // SERVICES
  private readonly dvmService:   DvmService               = inject(DvmService);

  // GLOBAL STATE
  public readonly  view:         Signal<AppViews | null>  = this.dvmService.view;

  // BUTTON STYLE
  public readonly  type:         ButtonType               = ButtonType.Pill;

  // COMPONENT STATE
  public           showElement:   boolean                 = this.view() !== AppViews.Pano;
  protected        showContainer: WritableSignal<boolean> = signal(false);
  protected        showContainerElement:    boolean = true; 
  protected version: string = version;

  // EFFECTS
  private readonly onViewChange:  EffectRef                = effect((): void => {

    const view: AppViews | null = this.view(),
          show: boolean = view !== AppViews.Pano;

    if(view === null) return;
    
    // Si está oculto, esperamos 300ms antes de animar el botón (que es lo que tardan los botones del viewer 3d en ocultarse)
    if (this.showElement) {
      setTimeout((): void => this.animateLegend(show), 300);
    } 
    else {
      this.animateLegend(show);
    }

    untracked(() => this.toggleContainer(false));

  }, { allowSignalWrites: true });

  private animateLegend(show: boolean): void {
    
    anime({
      begin:    (): void => { if(show && !this.showElement) this.showElement = true },
      complete: (): void => { if(!show && this.showElement) this.showElement = false },
      targets:  this.legendBtn.nativeElement,
      opacity:  show ? 1 : 0,
      duration: 300,
      easing:   'easeInOutQuad',
    })

  }

  protected toggleContainer(show: boolean): void {
    this.showContainer.set(show);
    if(!this.showContainerElement && this.showContainer()) this.showContainerElement = true;

    anime.timeline({
      complete: (): void => { 
        if(!this.showContainer()) this.showContainerElement = false;
      }, 
      duration: this.showContainer() ? 300 : 200,
      easing: this.showContainer() ? 'easeInOutQuad' : 'easeInOutCubic',
    })
    .add({
      targets: this.legendContent.nativeElement,
      opacity: this.showContainer() ? 1 : 0,
    })
  }
}
